import { AfterViewInit, Component, ElementRef, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Globle } from 'src/assets/globle';
import { DirectCharge } from './directCharge.model';
import { DirectChargeService } from './direct-charge.service';
import { LocalStorageService } from 'ngx-webstorage';
import { Clipboard } from '@angular/cdk/clipboard';
import { OptionService } from '../option.service';
import { Users } from '../users/users.model';
import { FormControl } from '@angular/forms';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';

@Component({
  selector: 'app-direct-charge-orders',
  templateUrl: './direct-charge-orders.component.html',
  styleUrls: ['./direct-charge-orders.component.css'],
  queries: {
    contentRef: new ViewChild("Modal"),
    contentRef1: new ViewChild("ModalView"),
    contentRef2: new ViewChild("ModalViewImg"),
    contentRef3: new ViewChild("ModalConfirmReject"),
    contentRef4: new ViewChild("ModalViewInfo")
  },
})
export class DirectChargeOrdersComponent implements OnInit, AfterViewInit {

  directChargeList: DirectCharge[] = [];
  displayedColumns: string[] = ['orderId', 'date', 'userFullName', 'product', 'quantity', 'playerId',
    'name', 'cardCode', 'notes', 'imageUrl', 'action'];
  dataSource!: MatTableDataSource<DirectCharge>;
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;
  spinnerOverlay = false;
  public contentRef!: TemplateRef<any>;
  public contentRef1!: TemplateRef<any>;
  public contentRef2!: TemplateRef<any>;
  public contentRef3!: TemplateRef<any>;
  public contentRef4!: TemplateRef<any>;
  directCharge: DirectCharge = {} as DirectCharge;

  chargedStatus: { id: number, name: string }[] = [{ id: -1, name: "all" }, { id: 1, name: "chargedDone" },
  { id: 0, name: "notCharged" }, { id: 2, name: "rejected" }];
  selectedStatus: number = 0;


  imgView!: string;
  rejectReason: string = "";
  id: any;
  pageSize = 100;
  userLoginId!: string;
  users: Users[] = [];
  userControl = new FormControl();
  filteredOptions!: Observable<any[]>;
  selectedUserId: string = "";
  @ViewChild('fromDate') fromDate!: ElementRef;
  @ViewChild('toDate') toDate!: ElementRef;

  apiOrders = false;

  constructor(private service: DirectChargeService,
    private snackBar: MatSnackBar,
    private globle: Globle,
    private optionService: OptionService,
    private localStorage: LocalStorageService,
    private clipboard: Clipboard,
    private dialog: MatDialog) { }

  ngOnInit() {
    // this.displayedColumns = ['orderId', 'date', 'userFullName', 'product', 'playerId', 'notes', 'imageUrl', 'view', 'updateStatus', "reject", "delete"];
    this.pageSize = this.globle.pageSize;
    this.userLoginId = this.localStorage.retrieve("userInfo").userId
    this.getUsers();


  }

  ngAfterViewInit(): void {
    this.getDirectCharge();
    setInterval(() => { this.getDirectCharge(); }, 180000);
  }

  getUsers() {
    let userId = this.localStorage.retrieve("userInfo").userId
    this.optionService.getAllCustomers(userId).subscribe(data => {
      this.users = data;
      // var user = {} as Users;
      // user.fullName = "الجميع";
      // user.id = "";
      // this.users.unshift(user);
      this.autoCompleatFilter();
    }, error => {
      console.log(error)
    })
  }

  displayFn(user: Users): string {
    //return user && user.userName || user.fullName ? user.userName || user.fullName : '';
    return user != null ? (user.userName != null && user.fullName != null) ?
      (user.userName + " - " + user.fullName) : user.fullName != null ? user.fullName :
        user.userName != null ? user.userName : "" : "";
  }

  autoCompleatFilter() {
    this.filteredOptions = this.userControl.valueChanges
      .pipe(
        startWith(''),
        map(value => typeof value === 'string' ? value : value != null ? value.name : ""),
        map(name => name ? this._filter(name) : this.users.slice())
      );
  }

  private _filter(name: string): Users[] {
    const filterValue = name.toLowerCase();

    return this.users.filter(option => option.userName.indexOf(filterValue) === 0 || option.fullName.toLowerCase().indexOf(filterValue) === 0);
  }

  selectUserChange(value: any) {
    this.selectedUserId = value.id;
  }

  getDirectCharge() {
    this.spinnerOverlay = true;

    this.service.get(this.selectedStatus, this.selectedUserId, this.fromDate.nativeElement.value,
      this.toDate.nativeElement.value, this.apiOrders).subscribe(data => {
        this.directChargeList = data.sort((n1, n2) => n2.id - n1.id);
        this.dataSource = new MatTableDataSource(this.directChargeList);
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
        this.spinnerOverlay = false;
      },
        error => {
          this.spinnerOverlay = false;
          console.log(error);
        })
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  edit(item: any) {
    // this.message_text = item.message;
    this.openDialogView();
  }

  onSearch() {
    this.getDirectCharge();
  }

  clearUser() {
    this.selectedUserId = "";
    this.userControl.reset();
  }

  openSnackBar(message: string, cssclass: string) {
    this.snackBar.open(message, 'Close', {
      duration: 6000,
      horizontalPosition: 'end',
      verticalPosition: 'top',
      panelClass: cssclass
    });
  }

  openDialog(): void {
    const dialogRef = this.dialog.open(this.contentRef, {
      width: '300px',
    });
  }

  openDialogView(): void {
    const dialogRef = this.dialog.open(this.contentRef1, {
      width: '500px',
    });
  }

  onNoClick(): void {
    this.dialog.closeAll();
  }

  viewImg(img: any) {
    this.imgView = img;
    this.openDialogImg();
  }

  openDialogImg(): void {
    const dialogRef = this.dialog.open(this.contentRef2, {
      width: '1000px',
      height: '1000px'
    });
  }

  openDialogReject(): void {
    const dialogRef = this.dialog.open(this.contentRef3, {
      width: '250px',
      height: '250px'
    });
  }

  openDialogViewInfo(): void {
    const dialogRef = this.dialog.open(this.contentRef4, {
      width: '300px',
    });
  }

  onChargedDone(item: DirectCharge) {
    this.spinnerOverlay = true;
    this.directCharge = item;
    var obj = {
      id: item.id,
      status: 1,
      rejectReason: "",
      compleateBy: this.userLoginId
    }
    this.service.updateStatus(obj).subscribe(data => {
      this.createPermNotification("تم شحن بطاقة  " + this.directCharge.product,
        "تم شحن بطاقة  " + this.directCharge.product, this.directCharge.playerId);
      this.openSnackBar("تم التعديل بنجاح", 'snackBarSuccess');
      this.spinnerOverlay = false;
      this.getDirectCharge();
    },
      error => {
        console.log(error);
        this.spinnerOverlay = false;
        this.dialog.closeAll();
        if (error.error.message) {
          this.openSnackBar(error.error.message, "snackBarError");
        }
        else {
          this.openSnackBar("حدث خطأ بالنظام", "snackBarError");
        }
      })

  }

  onReject(item: DirectCharge) {
    this.directCharge = item;
    this.openDialogReject();
  }

  confirmReject() {
    this.spinnerOverlay = true;

    var obj = {
      id: this.directCharge.id,
      status: 2,
      rejectReason: this.rejectReason,
      compleateBy: this.userLoginId
    }

    this.service.updateStatus(obj).subscribe(data => {
      this.createPermNotification("تم رفض شحن بطاقة  " + this.directCharge.product +
        "- (سبب الرفض : " + this.rejectReason + ")",
        "تم رفض شحن بطاقة  " + this.directCharge.product +
        "- (سبب الرفض : " + this.rejectReason + ")", this.directCharge.playerId);
      this.openSnackBar("تم التعديل بنجاح", 'snackBarSuccess');
      this.spinnerOverlay = false;
      this.getDirectCharge();
      this.dialog.closeAll();
    },
      error => {
        console.log(error);
        this.spinnerOverlay = false;
        this.dialog.closeAll();
        if (error.error.message) {
          this.openSnackBar(error.error.message, "snackBarError");
        }
        else {
          this.openSnackBar("حدث خطأ بالنظام", "snackBarError");
        }
      })
  }

  openSnackBarCopy(playerId: string) {
    this.snackBar.open("تم نسخ  " + playerId, 'Close', {
      duration: 2000,
      horizontalPosition: 'center',
      verticalPosition: 'bottom',
      panelClass: "snackBarSuccess"
    });
  }

  copyPlayerId(playerId: string) {
    this.clipboard.copy(playerId);
    this.openSnackBarCopy(playerId);
  }

  createPermNotification(permNotfbody: string, pushNotifBody: string, playerId: string) {
    var obj =
    {
      "title": "شحن مباشر",
      "message": permNotfbody,
      "usersIds": [this.directCharge.userId],
      "createBy": this.userLoginId,
      "playerId": playerId
    }

    this.optionService.createPermNotifications(obj).subscribe(data => {
      // this.sendNotification(this.directCharge.fcmToken, pushNotifBody);
      this.sendNotification(this.directCharge.fcmToken, pushNotifBody);
    }, error => {
      console.log(error);
    })
  }

  sendNotification(fcmToken: string, body: string) {

    var obj = {
      "fcmToken": fcmToken,
      "title": "شحن مباشر",
      "body": body
    }

    this.optionService.sendPushNotification(obj).subscribe(data => {
      console.log(data)
    },
      error => {
        console.log(error)
        this.openSnackBar(error, 'snackBarError');
        this.spinnerOverlay = false;
      })
  }

  viewInfo(data: any) {
    this.directCharge = data
    this.openDialogViewInfo()
  }

}
